import { performRequestAsyncMassAction } from '../../../../api'
import {
  getItemsIds,
  getMassActionSelectedItems,
} from '../../../../utils/common'
import { getRequestDocFlowsPayload } from '../../../../utils/docFlow'
import { DocFlowSelectModal } from '../../../DocFlowSelectModal'
import {
  REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
  REQUEST_MASS_ACTION_NAMES,
} from '../../Request.constants.actions'
import { useRequestConnectDocFlowsModalOpener } from '../useRequestConnectDocFlowsModalOpener'
import { useRequestCreateDocFlow } from '../useRequestCreateDocFlow'

export function useRequestTableDocFlowActions({
  excludeIds,
  pageItems,
  runMassAction,
  selectAllPages,
  selected,
  selectedIds,
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { handleOpenDocFlowCreation } = useRequestCreateDocFlow({
    onCloseModal,
    onReload,
    onSetModal,
  })

  const { handleOpenConnectDocFlows } = useRequestConnectDocFlowsModalOpener({
    onCloseModal,
    onReload,
    onSetModal,
  })

  // Linking doc flows is a Django async mass action: explicit request ids only,
  // no listing filters, so it is not offered for a select-all-pages selection.
  async function handleMassConnectDocFlows({ selected: docFlows }) {
    runMassAction({
      action: REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
      countOfItems: selectedIds.length,
      performAction: () =>
        performRequestAsyncMassAction({
          action:
            REQUEST_MASS_ACTION_NAMES[REQUEST_ACTION_CONNECT_DOC_FLOW_MASS],
          ids: selectedIds,
          payload: getRequestDocFlowsPayload(getItemsIds(docFlows)),
        }),
    })
  }

  function handleConnectDocFlowsToSelected() {
    onSetModal(
      <DocFlowSelectModal
        showLimitNotification
        onAttach={handleMassConnectDocFlows}
        onClose={onCloseModal}
      />
    )
  }

  function handleCreateDocFlowForItem(item) {
    handleOpenDocFlowCreation([item])
  }

  function handleCreateDocFlowForSelected() {
    handleOpenDocFlowCreation(
      getMassActionSelectedItems({
        excludeIds,
        pageItems,
        selectAllPages,
        selected,
      })
    )
  }

  return {
    handleConnectDocFlowsToItem: handleOpenConnectDocFlows,
    handleConnectDocFlowsToSelected,
    handleCreateDocFlowForItem,
    handleCreateDocFlowForSelected,
  }
}
